import React, { useContext } from 'react';
import context from '../../hoc/context/product/context';
import RichText from '../../hoc/components/rich-text';
import { FlowRouteProps } from '../flow/flow';
import Issue from './issue';
import { EventCategory } from '../../../services/ga-enums-interfaces';

function TechnicalIssue({ flow }: FlowRouteProps) {
	const ctxt = useContext(context);
	return (
		<Issue
			path={EventCategory.Issue}
			flow={flow}
			title={ctxt.json.pages.issue.header}
			label={ctxt.json.pages.issue.label}>
			<div className="flex flex-col gap-5 text-left">
				<div className="text-2xl">{ctxt.json.pages.issue.message}</div>
				<div className="text-lg">
					<RichText html={ctxt.json.pages.issue.contact} />
				</div>
			</div>
		</Issue>
	);
}

export default TechnicalIssue;
